import { Component, effect, input, output, signal } from '@angular/core';
import {
  GcPaginationComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import {
  TableToolbarComponent,
  TableToolbarConfig,
} from '../table-toolbar/table-toolbar.component';

export interface GcTableWrapperConfig {
  title?: string;
  titleCount?: number;
  tableToolbar?: TableToolbarConfig;
  pagination?: TablePaginationConfig;
}

export interface TablePaginationConfig {
  activePage?: number;
  numberOfPages: number;
}

@Component({
  selector: 'app-gc-table-wrapper',
  imports: [
    TableToolbarComponent,
    GcPaginationComponent,
    GcTextComponent,
    IpoTranslatePipe,
  ],
  templateUrl: './gc-table-wrapper.component.html',
  styleUrl: './gc-table-wrapper.component.scss',
})
export class GcTableWrapperComponent {
  data = input.required<GcTableWrapperConfig>();

  itemsPerPageSelected = output<number | null>();
  searchInputChanged = output<string>();
  paginationChanged = output<number>();

  localActivePage = signal<number>(1);

  constructor() {
    effect(() => this.setLocalActivePage());
  }

  setLocalActivePage(): void {
    const page = this.data().pagination?.activePage;
    if (this.localActivePage() !== page) {
      this.localActivePage.set(page ?? 1);
    }
  }

  setItemsPerPage(option: number | null): void {
    this.itemsPerPageSelected.emit(option);
  }

  onSearchInputChanged(inputString: string): void {
    this.searchInputChanged.emit(inputString);
  }

  onPaginationChanged(value: number): void {
    this.localActivePage.set(value);
    this.paginationChanged.emit(value);
  }
}
